import { defineStore } from 'pinia'
import { readonly, ref } from 'vue'

type SetupSettings = {
  userAvatarList?: { id: number; avatar: string }[]
  currencyList?: { currency: string; icon: string }[]
}

function getSetupSettings(): SetupSettings {
  const saved = localStorage.getItem('setupSettings')
  return saved ? JSON.parse(saved) : {}
}

function saveSetupSettings(newSettings: SetupSettings) {
  const existing = getSetupSettings()
  const updated = { ...existing, ...newSettings }
  localStorage.setItem('setupSettings', JSON.stringify(updated))
}

export const useSetupSettingsStore = defineStore('setupSettings', () => {
  // Load existing settings from localStorage
  const saved = getSetupSettings()

  const userAvatarList = ref(saved.userAvatarList ?? [])
  const currencyList = ref(saved.currencyList ?? [])

  function updateSetupSettings(settings: SetupSettings) {
    if (settings.userAvatarList) {
      userAvatarList.value = settings.userAvatarList
    }
    if (settings.currencyList) {
      currencyList.value = settings.currencyList
    }

    saveSetupSettings(settings)
  }

  return {
    userAvatarList: readonly(userAvatarList),
    currencyList: readonly(currencyList),
    updateSetupSettings,
  }
})
